import React from "react";
import { Link } from "react-router-dom";
import localizationStrings from "../utils/localizations";
import "./Home.css";

export default function Home() {
  return (
    <div className="home-container">
      <div className="home-page-login">
        <Link class="button" to={"/login"}>
          {localizationStrings.AdminLogin}
        </Link>
      </div>
      <img src={require("./../assets/images/logo-irshad.png")} className="image" alt="Unable to load" />
      <div
        class="hero-cta"
        style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}
      >
        {/* <a class="button" href={"/apk/Irshadni_5.2.apk"} download>
          {localizationStrings.DownloadIrshadniApp}
        </a>
        <div style={{ height: 20 }} /> */}
        {/* <a class='button' href={"/apk/IrshadniEmployee_1.0.2.apk"} download>
          {localizationStrings.DownloadIrshadniEmployeeApp}
        </a> */}
      </div>
      {/* <div class='hero-cta' style={{ paddingTop: '10px' }}>
        <a class='button' href={require('./../assets/apk/Irshadni_2.8_beta.apk')} download>
          Download Beta Irshadni Application
        </a>
      </div> */}
    </div>
  );
}
